"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildMembershipRenewalMockData = exports.FROALA_MEMBERSHIP_NOTE_BODY = void 0;
const email_body_html_1 = require("../../helpers/email-body-html");
const email_theme_tokens_1 = require("../../helpers/email-theme-tokens");
const icons_1 = require("../icons");
const email_templates_1 = require("../../internationalization/locales/email-templates");
const FROALA_PARAGRAPH_STYLE = "width:100%;margin:0px;box-sizing:inherit;color:rgb(0, 0, 0);line-height:1.5;";
exports.FROALA_MEMBERSHIP_NOTE_BODY = `<p style="${FROALA_PARAGRAPH_STYLE}">Hello John,</p>
<p style="${FROALA_PARAGRAPH_STYLE}">Your membership with The Cool Foundation is expiring soon. We'd love to have you with us for another year of making a difference together.</p>
<p style="${FROALA_PARAGRAPH_STYLE}">Renewing takes just a minute and keeps all your member benefits active.</p>
<p style="${FROALA_PARAGRAPH_STYLE}">Thank you for your continued support!</p>
<p style="${FROALA_PARAGRAPH_STYLE}"><strong>The Cool Foundation Team</strong></p>`;
const buildMembershipRenewalMockData = ({ orgName, color, isDarkMode, body, locale = "en", subject = "Your membership is expiring soon", }) => {
    const theme = (0, email_theme_tokens_1.resolveEmailThemeTokens)(color || "#FFFFFF", isDarkMode ? "dark" : "light");
    const iconZeffyLogo = theme.zeffyLogoVariant === "dark" ? icons_1.EMAIL_ICON_DATA_URI.zeffyDark : icons_1.EMAIL_ICON_DATA_URI.zeffyLight;
    return {
        labels: (0, email_templates_1.getEmailLabels)(locale),
        theme,
        iconZeffyLogo,
        lang: locale,
        subject,
        orgName: orgName || "Bright Futures Foundation",
        message: (0, email_body_html_1.applyCtaButtonTheme)(body || exports.FROALA_MEMBERSHIP_NOTE_BODY, { ctaBg: theme.ctaBg, ctaText: theme.ctaText }),
    };
};
exports.buildMembershipRenewalMockData = buildMembershipRenewalMockData;
